import {
  ChecklistReportType,
} from '../../../service/Reports';
import Reports from '../../../service/Reports';
import { useParams } from 'react-router-dom';
import ModalDetailPrint from './ModalDetailPrint';
import QueryFn from '../../../helpers/QueryFn';

const queryFn = new QueryFn();
const reportsService = new Reports();

export default function LinkExterno() {
  const params = useParams();

  const userTimestamp = {
    user: params.user,
    timestamp: Number(params.timestamp)
  };

  const { data, isLoading } = queryFn.useFetch('GET_LINK_EXTERNO',
    async () => {
      try {

        if (!params.timestamp) {
          const response = await reportsService.getExecutionById(String(params.formId));
          return response.execucao;
        } else {
          const response = await reportsService.getExecutionById(String(params.formId), userTimestamp);
          return response.execucao;
        }
      } catch (error) {
        console.error(error);
      }
    }
  );

  return (
    !isLoading &&
    <ModalDetailPrint
      openModal={true}
      isLoadingLink={isLoading}
      selected={data as ChecklistReportType} />
  );
}
